import React from "react";
import { Paper, Button, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

function MyItemsMenuPage() {
  const navigate = useNavigate();
  return (
    <Paper elevation={3} sx={{ p: 4, textAlign: 'center', maxWidth: 350, margin: '40px auto' }}>
      <Typography variant="h6" gutterBottom>
        Your items ( మీ   వస్తువులు )
      </Typography>
      <Box display="flex" flexDirection="column" gap={2}>
        <Button
          variant="contained"
          color="info"
          onClick={() => navigate("/my-found-items")}
        >
          My Found Items
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => navigate("/my-lost-items")}
        >
          My Lost Items
        </Button>
        <Button
          variant="outlined"
          onClick={() => navigate("/")}
        >
          Back
        </Button>
      </Box>
    </Paper>
  );
}
export default MyItemsMenuPage;